import { Action } from "redux";

// Action types
export enum AuthActionType {
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_FAILURE = "LOGIN_FAILURE",
    LOGOUT = "LOGOUT",
    SET_QUOTE_ADMIN_MODELS = "SET_QUOTE_ADMIN_MODELS",
    SET_OPTION_STATE = "SET_OPTION_STATE",
    SET_MODEL_STATE = "SET_MODEL_STATE",
    SET_QUOTE_STATE = "SET_QUOTE_STATE",
}

// Action creators
export interface LoginSuccessAction
    extends Action<typeof AuthActionType.LOGIN_SUCCESS> {
    payload: { token: string };
}

export interface LoginFailureAction
    extends Action<typeof AuthActionType.LOGIN_FAILURE> {
    payload: { error: string };
}

export interface LogoutAction extends Action<typeof AuthActionType.LOGOUT> { }

export interface SetQuoteAdminModelsAction
    extends Action<typeof AuthActionType.SET_QUOTE_ADMIN_MODELS> {
    payload: { quoteModels: any };
}

export interface SetOptionStateAction
    extends Action<typeof AuthActionType.SET_OPTION_STATE> {
    payload: { optionState: any };
}

export interface SetModelStateAction
    extends Action<typeof AuthActionType.SET_MODEL_STATE> {
    payload: { modelState: any };
}

export interface SetQuoteStateAction
    extends Action<typeof AuthActionType.SET_QUOTE_STATE> {
    payload: { quoteState: any };
}

// Union type for all auth actions
export type AuthActionTypes =
    | LoginSuccessAction
    | LoginFailureAction
    | LogoutAction
    | SetQuoteAdminModelsAction
    | SetOptionStateAction
    | SetModelStateAction
    | SetQuoteStateAction;

// Action creators
export const loginSuccess = (token: string): LoginSuccessAction => ({
    type: AuthActionType.LOGIN_SUCCESS,
    payload: { token },
});

export const loginFailure = (error: string): LoginFailureAction => ({
    type: AuthActionType.LOGIN_FAILURE,
    payload: { error },
});

export const logout = (): LogoutAction => ({
    type: AuthActionType.LOGOUT,
});

export const setQuoteAdminModels = (quoteModels: any): any => ({
    type: AuthActionType.SET_QUOTE_ADMIN_MODELS,
    payload: { quoteModels },
});

export const setOptionState = (optionState: any): any => ({
    type: AuthActionType.SET_OPTION_STATE,
    payload: { optionState },
});

export const setModelState = (modelState: any): any => ({
    type: AuthActionType.SET_MODEL_STATE,
    payload: { modelState },
});

export const setQuoteState = (quoteState: any): any => ({
    type: AuthActionType.SET_QUOTE_STATE,
    payload: { quoteState },
});
